export enum DashboardMode {
  LTC = 'LTC',
  Expert = 'EXPERT',
}